import { useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getProfessionalDetails } from '../services/clinicianManagmentPreCache';
import professionalDetailsFetchedAction from '../actions/professionalDetailsFetchedAction';

const useProfessionalDetails = (
  professionalId,
  { enabled = true } = {},
) => {
  const dispatch = useDispatch();
  const professionalsFetchedFlag = useSelector(
    (state) => state.professionalDetailsFetched,
  );

  const fetchProfessionalDetails = useCallback(async () => {
    try {
      dispatch(professionalDetailsFetchedAction('FETCHING'));
      const professionalDetails = await getProfessionalDetails(
        professionalId,
      );
      if (professionalDetails) {
        dispatch(professionalDetailsFetchedAction('FETCHED'));
      } else {
        dispatch(professionalDetailsFetchedAction('NOFETCH'));
      }
      return professionalDetails;
    } catch (error) {
      dispatch(professionalDetailsFetchedAction('NONE'));
      console.error('Failed to fetch professionals:', error);
      return null;
    }
  }, [dispatch, professionalId]);

  useEffect(() => {
    if (!enabled) return;
    if (professionalsFetchedFlag === 'NONE') {
      fetchProfessionalDetails();
    }
  }, [enabled, professionalsFetchedFlag, fetchProfessionalDetails]);
};

export default useProfessionalDetails;
